import React from 'react';
import prize1 from '../assets/Nagrody-konkurs-masaz.png'; // Import the image file
import prize2 from '../assets/Nagrody-konkurs-szkolenie.png';

function ThankYou({ result, onRestart, openAnswer }) {
  return (
    <div className="thank-you-container">
      <h2 className="thank-you-title">Dziękujemy za wypełnienie quizu!</h2>
      <div className="result-container">
        <h3 className="result-title">Twój wynik:</h3>
        <div className="result-badge">
          <div className="result-badge-text">Poprawnych odpowiedzi:</div>
          <div className="result-badge-value">{result}</div>
        </div>
        <h3 className="open-answer-title">Twoja odpowiedź na ostatnie pytanie:</h3>
        <p className="open-answer">{openAnswer}</p>
      </div>
      <button onClick={onRestart} className="restart-button">Rozpocznij ponownie</button>
      <p className="result-description">Jeśli Twoja odpowiedź wyjątkowo przypadnie do gustu jury, otrzymasz informację na ten temat do 8 maja z adresu contact@good-people.pl</p>
      <div className="prize-container">
        <h2 className="prize-title">Nagrody</h2>
        <div className="prize-description">
          Cenisz sobie praktyczną wiedzę z branży HR? <strong>Akademia Rekrutera jest dla Ciebie!</strong>
        </div>
        <div className="prize-images">
          <img src={prize2} alt="Nagroda szkolenie" className="prize-image" />
        </div>
        <h2 className="prize-title">Sprawdź, o co walczysz!</h2>
        <div className="prize-description">
        Akademia Rekrutera to cykliczne warsztaty organizowane przez OLX Praca. Podczas spotkań dzielimy się swoim know-how, przedstawiamy wewnętrzne dane i pokazujemy, jak wykorzystać wiedzę w&nbsp;praktyce. W tegorocznej edycji Akademii Rekrutera odkrywamy, jak wykorzystać perspektywę kandydatów jako fundament skutecznej rekrutacji i tworzyć komunikację w pełni dopasowaną do kandydatów.
        <br/><br/><strong>Zobacz, jak wyglądała poprzednia edycja warsztatów.</strong>

        </div>
        <div className="prize-video">
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/wp8mj2pv4HU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;